var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-button-component"},[_c('button',{staticClass:"cell-button btn btn-sm",class:[ 'btn-'+_vm.color ],on:{"click":function($event){return _vm.buttonClick(_vm.value)}}},[_c('i',{staticClass:"icon fa",class:[ _vm.icon ]}),_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }